/* istanbul ignore file */
import { BigFormRow } from 'framework/ui/layout';
import { WysiwygInput } from 'framework/form';

const NoteForm = () => (
  <BigFormRow>
    <WysiwygInput source="content" label="Note text" />
  </BigFormRow>
);

export default NoteForm;
